export const htmlCacheName = 'html-cache';
export const staticHtmlCacheKey = 'static-html-key';
export const fontsCacheName = 'fonts-cache';
export const staticAssetsCacheName = 'static-assets-cache';

export const bypassHtmlCacheRegex: RegExp = new RegExp(/(branch|version)=/i);
export const legacyFluentFontAssetsRegex: RegExp = new RegExp('^https://res-1\\.cdn\\.office\\.net/files/');
export const jsCssAssetsRegex: RegExp = /\.(js|css)$/;
